import React from 'react';

type Props = {};

const Search: React.FC<Props> = () => {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.20458" cy="8.20458" r="7.20458" stroke="#D77B8B" strokeWidth="2" />
      <path d="M12.9515 13.8181L18.1333 19" stroke="#D77B8B" strokeWidth="2" />
    </svg>
  );
};

export default Search;
